import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import routes from '../routes/route';
import viewRelatedRoomTags from './viewRelatedRoomTags';
import viewRelatedSportsRooms from './viewRelatedSportsRooms';
import { OPERATING_SYSTEMS } from '../utils/operatingSystemUtils';
import viewRelatedConfigThirdParty from './viewRelatedConfigThirdParty';
export default {
  attributeName: 'mainHubConfig',
  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canModify: true,
  canRemove: true,
  modifyURL:routes.MH_CONFIG_RULES,
  editURL: routes.MH_CONFIG_EDIT,
  createPath: routes.MH_CONFIG_NEW,
  emptyMessage: "You don't have any configs yet. Click the \"New\" button to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name of the config',
      default: '',
      canEdit: true,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'entry_points',
      label: 'Entry Point',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      blockItemRemove: true,
      maxElements: 1,
      configFile: viewRelatedSportsRooms,
      default: [],
      helpText: 'Define the main room to be shown as main room.',
      exactWidth: '10rem',

    },
    {
      attributeName: 'availableProviders',
      label: 'Available Provider',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewRelatedConfigThirdParty,
      default: [],
      helpText: 'Select the authentication provider required to access this MainHub.',
      exactWidth: '10rem',
    },
    {
      attributeName: 'operatingSystem',
      label: 'Operating System ',
      helpText: 'Specifies the operating system of this config.',
      default: '(Empty)',
      canEdit: false,
      canCreate: true,
      canFilter: false,
      emptyValue: true,
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Oculus Quest', value: OPERATING_SYSTEMS.oculusQuest.key },
        { name: 'Android XR VR', value: OPERATING_SYSTEMS.androidXR.key },
        { name: 'Apple Vision PRO', value: OPERATING_SYSTEMS.visionOS.key },
      ],
    },
    {
      attributeName: 'id',
      label: 'Export Client API',
      type: FormInputTypes.BUTTON_POPUP,
      iconSize: '2x',
      icon: IconType.EXPORT,
      helpText: 'To export the client API and their media resources',
      canOrder: false,
      canFilter: false,
      exactWidth: '100px',
      openUrl: 'exportClientAPI',
      formConfig:
      {
        title: 'Exporting Client API',
        description: 'The Zip link will appear when the process is complete:',
        fields: [
          {
            type: FormInputTypes.WEBSOCKET_LOG,
            attributeName: 'exportClientAPIMonitoring',
            websocketChannel: 'exportClientAPIMonitoring',
            websocketParam: 'id',
            elementsFromWebsocket: ['zipFile', 'isFinished']
          },
          {
            attributeName: 'zipFile',
            label: 'Zip File',
            type: FormInputTypes.LINK,
            icon: IconType.LINK,
            helpText: 'The file to download.',
            hasClick: true,
            visibleWhen: { field: 'isFinished', value: true }
          }
        ]

      },
    },
  ],
};
